
import { axios, BaseApiUrl ,BaseUrl} from '../axios_config';


export const getDepartmentList = params => {
    return axios.get(`${BaseApiUrl}/ProductionReport/GetDepartment`, { params: params });
};

export function GetReceivingProductionOperationTypeList(params) {
    return axios.post(`${BaseApiUrl}/Util/GetReceivingProductionOperationTypeList`, params);
}

export function GetWareProductionReport(params) {
    return axios.post(`${BaseApiUrl}/ProductionReport/GetWareProductionReport`, params);
}
//导出
export const WareProductionExport= `${BaseApiUrl}/ProductionReport/WareProductionExport`;